import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { baseUrl } from '../Data/service/global.service';

@Injectable({
  providedIn: 'root'
})
export class MerchantPaymentService {
  constructor(private http: HttpClient) {}

  cancelPendingOrder(orderId: number): Observable<any> {
    return this.http.delete<any>(`${baseUrl}invoice-subscriptions-v2/orders/${orderId}`);
  }

  registerCard(merchantId: number, userId?: number, language?: string): Observable<{ paymentUrl: string }> {
    const body: any = {};
    if (userId) body.userId = userId;
    if (language) body.language = language;
    return this.http.post<{ paymentUrl: string }>(
      `${baseUrl}card-registration/merchant/${merchantId}/register-card`,
      body
    );
  }

  /** GET card-registration/merchant/:id/saved-card-status */
  getSavedCardStatus(merchantId: number): Observable<{ has_active_saved_card: boolean }> {
    return this.http.get<{ has_active_saved_card: boolean }>(
      `${baseUrl}card-registration/merchant/${merchantId}/saved-card-status`,
    );
  }

  getCards(merchantId: number): Observable<any[]> {
    return this.http.get<any[]>(`${baseUrl}card-registration/merchant/${merchantId}/cards`);
  }

  getCard(merchantId: number, cardId: number): Observable<any> {
    return this.http.get<any>(`${baseUrl}card-registration/merchant/${merchantId}/cards/${cardId}`);
  }

  activateCard(merchantId: number, cardId: number): Observable<any> {
    return this.http.patch<any>(
      `${baseUrl}card-registration/merchant/${merchantId}/cards/${cardId}/activate`,
      {}
    );
  }

  deactivateCard(merchantId: number, cardId: number): Observable<any> {
    return this.http.patch<any>(
      `${baseUrl}card-registration/merchant/${merchantId}/cards/${cardId}/deactivate`,
      {}
    );
  }

  deleteCard(merchantId: number, cardId: number): Observable<void> {
    return this.http.delete<void>(
      `${baseUrl}card-registration/merchant/${merchantId}/cards/${cardId}`
    );
  }

  getTransactions(merchantId: number): Observable<any[]> {
    return this.http.get<any[]>(
      `${baseUrl}card-registration/merchant/${merchantId}/transactions`
    );
  }

  getInvoicePdfLink(invoiceId: number, lang: string): Observable<{ pdf_link: string }> {
    return this.http.get<{ pdf_link: string }>(
      `${baseUrl}invoices-v2/${invoiceId}/pdf?lang=${encodeURIComponent(lang)}`
    );
  }

  downloadReceipt(merchantId: number, transactionId: number): Observable<Blob> {
    return this.http.get(
      `${baseUrl}card-registration/merchant/${merchantId}/transactions/${transactionId}/receipt`,
      { responseType: 'blob' }
    );
  }
}

